export const maxBytesPerFile = 27000000;
export const maxBytesTotal = 27000000;
export const maxUploadBodySize = 30000000;
